/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */


const theme = {
  appearances: {
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { viewport: 'xl' },
      tokens: { contentMaxDimension: 184, imageDimension: 168 }
    },
    {
      if: { hover: true },
      tokens: { color: '#404040', imageDimension: 140, textLine: 'underline' }
    },
    {
      if: { focus: true },
      tokens: { color: '#000000', outerBorderColor: '#000000' }
    },
    {
      if: { pressed: true },
      tokens: {
        color: '#595959',
        outerBorderColor: '#595959',
        textLine: 'underline'
      }
    },
    {
      if: { focus: true, pressed: true },
      tokens: {
        color: '#595959',
        outerBorderColor: '#595959',
        textLine: 'underline'
      }
    },
    {
      if: { hover: true, viewport: 'xl' },
      tokens: { imageDimension: 184 }
    }
  ],
  tokens: {
    color: '#000000',
    contentAlignItems: 'center',
    contentDirection: 'column',
    contentMaxDimension: 168,
    contentSpace: 3,
    fontName: 'StagSans',
    fontSize: 16,
    fontWeight: '600',
    gap: 5,
    imageDimension: 128,
    outerBorderColor: 'rgba(0, 0, 0, 0)',
    textAlign: 'center',
    textLine: 'none'
  }
}
export default theme
